import "./styles.css";
import {useRef, useEffect} from 'react';


// ["29/11/21", "28/11/21", "27/11/21", "25/11/21", "2/11/21"]
function Calendar({fechas, filtrarFechas, resetearFechas, fechasInicial, isConsolidado}){
 console.log("EJECUTANDOSE CALENDAR")
 let monthNames = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
 

 let currentMonth = fechas.length && fechas[0][1] - 1;
 let currentYear = fechas.length && fechas[0][2];
 let nuevasFechas = fechas.length && [...fechas];
 console.log({nuevasFechas})
 let fechasIniciales = fechasInicial.length && [...fechasInicial];
 console.log({fechasIniciales})
 
 let $dates = useRef();
 let $month = useRef();
 let $year = useRef();

 let $prevMonth = useRef();
 let $nextMonth = useRef();

 let $dateInit = useRef();
 let $dateEnd = useRef();
 let $fechas = useRef();
// [[29, 11, 21], [28, 11, 21], [27, 11, 21], [25, 11, 21], [22, 11, 21], [19, 11, 21], [17, 11, 21]]
// ['30/11/21', '29/11/21']

 function selectDate(e){
   let date = e.target
   if(date.classList.contains('calendar__date') && date.classList.contains('calendar__item') && !date.classList.contains('calendar__last-days')){
     //!Validando que siempre haya una fecha
    if(!date.classList.contains('calendar__today-selected') || nuevasFechas.length !== 1){
      date.classList.toggle("calendar__today-selected");
      let new_date =[parseInt(date.textContent), currentMonth + 1, currentYear]
      console.log(new_date) 
      if(!nuevasFechas.some(fech => fech[0] === new_date[0] && fech[1] === new_date[1] && fech[2] === new_date[2])){
       nuevasFechas = [...nuevasFechas, new_date];
       nuevasFechas.sort(function(a, b){
         return new Date(b[2], b[1] - 1, b[0]).getTime() - new Date(a[2], a[1] - 1, a[0]).getTime() 
       })
       console.log("NO EXISTE")
       console.log(nuevasFechas);
       $dateInit.current.textContent = "FECHA MENOR: " + nuevasFechas[nuevasFechas.length - 1].join('/');
       $dateEnd.current.textContent = "FECHA MAYOR: " + nuevasFechas[0].join('/');
       $fechas.current.innerHTML= ''
       fechasIniciales.forEach((fech) => {
         if(nuevasFechas.some(nuev => nuev[0] === fech[0] &&  nuev[1] === fech[1] &&  nuev[2] === fech[2])){
           $fechas.current.innerHTML+= `<li className="list-group-item d-flex justify-content-between">${fech[0]}/${fech[1]}/${fech[2]} <span>✔</span></li>`
         }else{
           $fechas.current.innerHTML+= `<li className="list-group-item d-flex">${fech[0]}/${fech[1]}/${fech[2]}</li>`
         }
       })
      }else{
       nuevasFechas = nuevasFechas.filter(fech => new Date(fech[2], fech[1] - 1 , fech[0]).getTime() !== new Date(new_date[2], new_date[1] - 1, new_date[0]).getTime())
       console.log("EXISTE")
       console.log(nuevasFechas);
       $dateInit.current.textContent = "FECHA MENOR: " + nuevasFechas[nuevasFechas.length - 1].join('/');
       $dateEnd.current.textContent = "FECHA MAYOR: " + nuevasFechas[0].join('/');
       $fechas.current.innerHTML= ''
        //  nuevasFechas.forEach((fech) => {
        //    $fechas.current.innerHTML+= `<li className="list-group-item">${fech[0]}/${fech[1]}/${fech[2]}</li>`
        //  })
       fechasIniciales.forEach((fech) => {
         if(nuevasFechas.some(nuev => nuev[0] === fech[0] &&  nuev[1] === fech[1] &&  nuev[2] === fech[2])){
           $fechas.current.innerHTML+= `<li className="list-group-item d-flex justify-content-between">${fech[0]}/${fech[1]}/${fech[2]} <span>✔</span></li>`
         }else{
           $fechas.current.innerHTML+= `<li className="list-group-item d-flex">${fech[0]}/${fech[1]}/${fech[2]}</li>`
         }
       })
      }
    }
   }
 }
  
 function writeMonth(month){
  $dates.current.textContent = '';
  for(let i = startDay(); i>0; i--){
   $dates.current.innerHTML += `<div className="calendar__date calendar__item calendar__last-days">${getTotalDays(currentMonth - 1) - (i-1)}`
  }

  for (let i = 1; i<= getTotalDays(month); i++){
   let salvación = currentYear
   let comprobarDiaInicial = fechasIniciales.filter(fech => fech[0] === i).filter(fech => fech[1] === month + 1).filter(fech => fech[2] === salvación);
   let comprobarDiaMarcado = nuevasFechas.filter(fech => fech[0] === i).filter(fech => fech[1] === month + 1).filter(fech => fech[2] === salvación);

   if(comprobarDiaInicial.length && comprobarDiaMarcado.length){

    $dates.current.innerHTML+=`<div className="calendar__date calendar__item calendar__today calendar__today-selected">${i}</div>`
   }else if(comprobarDiaInicial.length){
    $dates.current.innerHTML+=`<div className="calendar__date calendar__item calendar__today">${i}</div>`
   }else{
    $dates.current.innerHTML+=`<div className="calendar__date calendar__item">${i}</div>`
    
   }
  }
 }

 function getTotalDays(month){
  if(month === -1) month = 11;

  if(month === 0 || month === 2 || month === 4 || month === 6 || month === 7 || month === 9 || month === 11){
   return 31;
  }else if(month === 3 || month === 5 || month === 8 || month === 10){
   return 30;
  } else{
   return isLeap() ? 29 : 28;
  }
 }

 function isLeap(currentYear){
  return (((currentYear % 100 !== 0) && (currentYear % 4 === 0)) || (currentYear % 400 === 0))
 }
 //! 0 lunes 6 domingo
 function startDay(){
  let start = new Date(currentYear, currentMonth, 1);
  return ((start.getDay() - 1 === -1) ? 6 : start.getDay() - 1)
 }

 function lastMonth(){
  if(currentMonth !== 0){
   currentMonth--;
  }else{
   currentMonth=11;
   currentYear--;
  }
  setNewDate();
 }

 function nextMonth(){
  if(currentMonth !== 11){
   currentMonth++;
  }else{
   currentMonth=0;
   currentYear++;
  }
  setNewDate();
 }

 function setNewDate(){
  // date.setFullYear(currentYear, currentMonth, currentDate);
  $month.current.textContent = monthNames[currentMonth];
  $year.current.textContent = "20" + currentYear.toString(); 
  writeMonth(currentMonth);
 }
 
 useEffect(() => {
  if(!fechas.length || !fechasInicial.length) return null;
  //!Cargar Mes y Año
  console.log({currentMonth: currentMonth + 1 , currentYear})
  $month.current.textContent = monthNames[currentMonth];
  $year.current.textContent = "20" + currentYear.toString();
  $dateInit.current.textContent = "FECHA MENOR: " + fechas[fechas.length - 1].join('/');
  $dateEnd.current.textContent = "FECHA MAYOR: " + fechas[0].join('/');
  $fechas.current.innerHTML = '';

  fechasIniciales.forEach((fech) => {
    if(nuevasFechas.some(nuev => nuev[0] === fech[0] &&  nuev[1] === fech[1] &&  nuev[2] === fech[2])){
      $fechas.current.innerHTML+= `<li className="list-group-item d-flex justify-content-between">${fech[0]}/${fech[1]}/${fech[2]} <span>✔</span></li>`
    }else{
      $fechas.current.innerHTML+= `<li className="list-group-item d-flex">${fech[0]}/${fech[1]}/${fech[2]}</li>`
    }
  })

  // fechas.forEach((fech) => {
  //   $fechas.current.innerHTML+= `<li className="list-group-item d-flex justify-content-between">${fech[0]}/${fech[1]}/${fech[2]} <span>✔</span></li>`
  // })

  //!Cargar dias  
  writeMonth(currentMonth);

  // eslint-disable-next-line
 }, [fechas, fechasInicial])

 return (
  <>
  <h5 className="text-center my-4">Por favor seleccione las fechas a filtrar</h5>
  {isConsolidado
  ?
  <h3 className="text-center my-4" style={{"color": "red", "fontWeight": "bolder"}}>{nuevasFechas.length} días coincidieron</h3>
  :
  ''
  }

  <div className="row d-flex">
    <div className="col-9">
      <div className="calendar mb-3">
        <div className="calendar__fecha">
          <div className="calendar__fecha--init" ref={$dateInit}></div>
          <div className="calendar__fecha--end" ref={$dateEnd}></div>
        </div>
        <div className="calendar__info">
          <div className="calendar__prev" id="prev-month" ref={$prevMonth} onClick={lastMonth}>&#9664;</div>
          <div className="calendar__month" id="month" ref={$month}></div>
          <div className="calendar__year" id="year" ref={$year}></div>
          <div className="calendar__next" id="next-month" ref={$nextMonth} onClick={nextMonth}>&#9654;</div>
        </div>
        
        <div className="calendar__week">
          <div className="calendar__day calendar__item-header">Lunes</div>
          <div className="calendar__day calendar__item-header">Martes</div>
          <div className="calendar__day calendar__item-header">Miércoles</div>
          <div className="calendar__day calendar__item-header">Jueves</div>
          <div className="calendar__day calendar__item-header">Viernes</div>
          <div className="calendar__day calendar__item-header">Sabado</div>
          <div className="calendar__day calendar__item-header">Domingo</div>
        </div>
        <div className="calendar__dates" id="dates" ref={$dates} onClick={(e) => selectDate(e)}></div>
      </div>
      <div className="d-flex justify-content-center align-items-center mb-3">
        <button className="mb-2 btn btn-primary mx-3" type="submit" onClick={() => filtrarFechas(nuevasFechas)}><i className="bi bi-save"></i>Filtrar Fechas</button>  

        <button className="mb-2 btn btn-success mx-3" type="submit" onClick={resetearFechas}><i className="bi bi-save"></i>Resetear Fechas</button>  
      </div>
    </div>
    <div className="col-3">
      <h6>Fechas del log:</h6>
      <ul className="list-group" ref={$fechas}>
      </ul>
      <div className="leyenda my-3">
        <h6>Leyenda</h6>
        <p className="d-flex align-items-center"><span>✔:</span>&nbsp;Fechas Seleccionadas</p>
        <p className="d-flex align-items-center"><span style={{display: "inline-block", backgroundColor: "lightcoral", width: "25px", height: "25px", borderRadius: "50%"}}></span>:&nbsp;Fechas Iniciales</p>
        <p><small><strong>NOTA: Seleccionar al menos una fecha</strong></small></p>
      </div>
    </div>
  </div>
  </>
 )
}
export default Calendar
